module.exports = __webpack_public_path__ + "img/icon-christmas.c94da50a.svg";